<script lang="ts">
	import { Asset } from '@atoms';
	import type { AssetBlock } from './AssetBlockQuery';
	import { getContext } from 'svelte';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';

	const { data }: { data: AssetBlock } = $props();
	const cssClasses = data.fixedAspectRatio ? 'fixedAspecRatio media' : 'media';

	const layout: string = getContext('page-layout') ?? 'default';
	createViewController();
</script>

<section class={layout} use:ViewController>
	<div class={cssClasses} use:EnterOnView>
		<Asset data={data.media} />
	</div>
</section>

<style lang="scss">
	.default {
		@include blockPadding(true, true);
	}
	.fullbleed {
		@include blockPaddingSmall(true, true);
	}
	.fullbleed-center {
		@include blockPaddingSmall(true, true);
	}

	section {
		@include layoutBlockGrid;

		.media {
			grid-column: 1 / -1;
		}

		.fixedAspecRatio {
			aspect-ratio: 1 / 1;

			@include md {
				aspect-ratio: 2.6 / 1;
			}
		}
	}
</style>
